import React from 'react';
import { Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AppRole } from '../../theme/tokens';

// export type LoginRole = 'parent' | 'organization' | 'administrator';
export type LoginRole = AppRole;

interface RoleSelectorProps {
  value: LoginRole;
  onChange: (role: LoginRole) => void;
}

// const ROLES: LoginRole[] = ['parent', 'organization', 'administrator'];
const ROLES: LoginRole[] = ['parent', 'organization'];

/**
 * Pill button group selecting which kind of account is logging in.
 *
 * The selected role would determine which authentication flow / backend
 * endpoint the login form targets. For now it only drives local UI state.
 */
export default function RoleSelector({ value, onChange }: RoleSelectorProps) {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: 'flex', gap: 1 }}>
      {ROLES.map((role) => {
        const selected = role === value;
        return (
          <Button
            key={role}
            onClick={() => onChange(role)}
            variant={selected ? 'contained' : 'outlined'}
            disableRipple
            sx={(theme) => ({
              minHeight: 36,
              px: 2,
              py: 1,
              borderRadius: '9999px',
              backgroundColor: selected ? theme.app.primary : 'transparent',
              color: selected ? theme.app.primaryForeground : theme.app.foreground,
              borderColor: selected ? theme.app.primary : theme.app.borderStrong,
              '&:hover': {
                backgroundColor: selected ? theme.app.primaryHover : theme.app.secondary,
                borderColor: selected ? theme.app.primaryHover : theme.app.borderStrong,
              },
            })}
          >
            {t(`header.roles.${role}`)}
          </Button>
        );
      })}
    </Box>
  );
}
